var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import "../types.js";
import { registerSystem, DEPTHS } from "../ComponentRegistry.js";
import { addVector2d } from "../../utils/vector.js";
import { toWorldSpace } from "../../utils/isometric.js";
import { T as TransformSchema } from "../../Transform-9450b7b5.js";
import { R as RigidPolygonSchema } from "../../RigidPolygon-b7405623.js";
import { C as ComponentCategory } from "../../enums-86f58524.js";
import "../../decorators/type.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../global-33d5eebf.js";
import "../../utils/byteArray.js";
class RigidPolygonSystem {
  constructor() {
    __publicField(this, "type", "RigidPolygon");
    __publicField(this, "category", ComponentCategory.PHYSICS);
    __publicField(this, "schema", RigidPolygonSchema);
    __publicField(this, "depth", DEPTHS.COLLISION - 1e-4);
  }
  init(entity, gameModel) {
    gameModel.getTypedUnsafe(entity, TransformSchema);
    const rigidPolygon = gameModel.getTypedUnsafe(entity, RigidPolygonSchema);
    const set = [];
    if (rigidPolygon.vertexIndicies.length !== 0) {
      for (let i = 0; i < rigidPolygon.vertexIndicies.length; i++) {
        const offset = rigidPolygon.vertexIndicies[i];
        const nextOffset = rigidPolygon.vertexIndicies[i + 1] || 0;
        const positionOffset = rigidPolygon.vertexOffsets[i] || { x: 0, y: 0 };
        const vertices = rigidPolygon.vertices.slice(offset, nextOffset || void 0).map((v) => {
          return toWorldSpace(addVector2d(v, positionOffset));
        });
        set.push(vertices);
      }
    } else {
      set.push(rigidPolygon.vertices);
    }
  }
  runAll(gameModel) {
    const entities = gameModel.getComponentActives("RigidPolygon");
    for (let i = 0; i < entities.length; i++) {
      entities[i];
    }
  }
  cleanup(entity, gameModel) {
  }
}
registerSystem(RigidPolygonSystem);
export {
  RigidPolygonSystem
};
//# sourceMappingURL=RigidPolygon.js.map
